import React from "react";

const GroupManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="57.854"
      height="40.89"
      viewBox="0 0 57.854 40.89"
    >
      <g id="db62" transform="translate(-205.464 -255.47)">
        <path
          id="Path_1346"
          data-name="Path 1346"
          d="M337.827,271.045a7.787,7.787,0,1,0-7.787-7.787A7.8,7.8,0,0,0,337.827,271.045Z"
          transform="translate(-103.445 0)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1347"
          data-name="Path 1347"
          d="M442.919,295.99a6.71,6.71,0,1,0-6.711-6.71A6.718,6.718,0,0,0,442.919,295.99Z"
          transform="translate(-191.604 -22.502)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1348"
          data-name="Path 1348"
          d="M243.279,295.99a6.71,6.71,0,1,0-6.711-6.71A6.718,6.718,0,0,0,243.279,295.99Z"
          transform="translate(-25.828 -22.502)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1349"
          data-name="Path 1349"
          d="M222.529,367.541a.8.8,0,0,0-.291-1.256,11.862,11.862,0,0,0-4.787-1,12,12,0,0,0-11.988,11.983.8.8,0,0,0,.8.8h12.187a.8.8,0,0,0,.8-.848c-.014-.239-.019-.484-.019-.727a13.845,13.845,0,0,1,3.292-8.96Z"
          transform="translate(0 -91.192)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1350"
          data-name="Path 1350"
          d="M411.687,388.065h-.96a8.122,8.122,0,0,0-.684-1.647l.679-.678a.8.8,0,0,0,.088-1.03,9.545,9.545,0,0,0-2.363-2.356.8.8,0,0,0-1.028.093l-.672.676a8.148,8.148,0,0,0-1.645-.682v-.959a.8.8,0,0,0-.663-.79,9.885,9.885,0,0,0-3.319,0,.8.8,0,0,0-.675.793v.963a8.024,8.024,0,0,0-1.634.672l-.672-.672a.8.8,0,0,0-1.03-.088,9.728,9.728,0,0,0-2.357,2.357.8.8,0,0,0,.088,1.03l.674.674a8.333,8.333,0,0,0-.68,1.645h-.959a.8.8,0,0,0-.791.665,9.525,9.525,0,0,0-.14,1.657,10.368,10.368,0,0,0,.138,1.66.8.8,0,0,0,.793.676h.963a7.888,7.888,0,0,0,.681,1.639l-.673.673a.8.8,0,0,0-.089,1.03,9.579,9.579,0,0,0,2.348,2.346.8.8,0,0,0,1.029-.089l.672-.672a8.135,8.135,0,0,0,1.641.68v.962a.8.8,0,0,0,.675.793,10.4,10.4,0,0,0,1.66.139,9.505,9.505,0,0,0,1.657-.14.8.8,0,0,0,.665-.791v-.959a8.273,8.273,0,0,0,1.645-.678l.673.674a.8.8,0,0,0,1.03.088,9.707,9.707,0,0,0,2.359-2.359.8.8,0,0,0-.088-1.03l-.673-.673a7.991,7.991,0,0,0,.673-1.633h.964a.8.8,0,0,0,.793-.676,10.533,10.533,0,0,0,.137-1.66,9.6,9.6,0,0,0-.139-1.656.8.8,0,0,0-.79-.665Zm-11.966,2.322a2.883,2.883,0,0,1,.215-1.116c.011-.027.021-.056.03-.084h0a3.091,3.091,0,0,1,1.6-1.607l.028-.013c.023-.007.048-.016.071-.025a3.055,3.055,0,0,1,2.244,0,.566.566,0,0,0,.064.023l.013.007a3.118,3.118,0,0,1,1.615,1.616c.008.025.017.05.027.076a2.933,2.933,0,0,1,.215,1.124,2.9,2.9,0,0,1-.213,1.116.694.694,0,0,0-.03.083l-.007.017a3.107,3.107,0,0,1-1.607,1.6.769.769,0,0,0-.085.03,3.049,3.049,0,0,1-2.254,0l-.076-.031a3.1,3.1,0,0,1-1.6-1.6l-.737.319.7-.406A2.967,2.967,0,0,1,399.721,390.387Z"
          transform="translate(-155.678 -103.864)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1351"
          data-name="Path 1351"
          d="M316.254,358.04a.8.8,0,0,0,.238-1.355,14.022,14.022,0,0,0-23.228,10.578.8.8,0,0,0,.8.8h14.776a.8.8,0,0,0,.8-.772,10.36,10.36,0,0,1,6.608-9.254Z"
          transform="translate(-72.907 -81.186)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1352"
          data-name="Path 1352"
          d="M467.807,377.083a12,12,0,0,0-11.988-11.817,11.837,11.837,0,0,0-3.51.53.8.8,0,0,0,.172,1.568,10.358,10.358,0,0,1,9.49,9.916.8.8,0,0,0,.8.772h4.246a.8.8,0,0,0,.8-.8.774.774,0,0,0-.017-.166Z"
          transform="translate(-204.505 -91.172)"
          fill={fill ? fill : "#4166f8"}
        />
      </g>
    </svg>
  );
};

export default GroupManagementIcon;
